import { render } from "./Akkor.vue?vue&type=template&id=35e780ce&scoped=true"
import script from "./Akkor.vue?vue&type=script&lang=js"
export * from "./Akkor.vue?vue&type=script&lang=js"

import "./Akkor.vue?vue&type=style&index=0&id=35e780ce&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Евадент\\eva\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e780ce"]])

export default __exports__